import __request__ from "routing/request";
export function simulate(simulation) {
  return __request__("POST", "/system/pipelines/simulate", simulation, {}, {
    "Accept": ["application/json"]
  });
}
